import { useMutation } from "@tanstack/react-query";

import {
  type GenerateVoicelinesRequest,
  postProjectsProjectIDJobsJobIDGenerateVoicelines,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";

export function useGenerateVoicelinesMutation(
  projectId: string,
  jobId: string,
) {
  return useMutation({
    mutationFn: processResponse(
      (request: GenerateVoicelinesRequest) =>
        postProjectsProjectIDJobsJobIDGenerateVoicelines(
          request,
          projectId,
          jobId,
        ),
      {
        translationPrefix: getResourcePath(
          Resources.ApiErrors.GenerateVoicelines,
        ),
      },
    ),
  });
}
